import { render, staticRenderFns } from "./LPopper.vue?vue&type=template&id=9a89e18e"
import script from "./LPopper.vue?vue&type=script&lang=js"
export * from "./LPopper.vue?vue&type=script&lang=js"
import style0 from "./LPopper.vue?vue&type=style&index=0&id=9a89e18e&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports